import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";

//<!-------On Bording Steps-------->

//Profile

export const SubmitSettingsProfile = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.settingsProfile, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSettingsProfile = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.settingsProfile, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//sensors

export const GetCompanySensors = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.linkSensorsAccount, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteCompanySensor = (id, token) => {
  const url = `${APIPaths.linkSensorsAccount}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//locations

export const GetSettingsLocations = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.settingsLocation, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetLocationById = (token, id) => {
  const url = `${APIPaths.settingsLocation}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const AddSettingsLocation = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.settingsLocation, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSettingsCouriers = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.transportProvider, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// fetch company couriers for new settings screen.
export const GetSettingsNewCouriers = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.transportProviderDetail, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};
//get settings courier by id
export const GetSettingsNewCouriersById = (id, token) => {
  const url = `${APIPaths.transportProviderDetail}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSettingCourierById = (token, id) => {
  const url = `${APIPaths.courierContacts}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const LinkSettingsCourierAccount = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.courierContacts, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// export const SubmitCourierContacts = (token, model) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosPost("Post", APIPaths.courierContacts, model, token).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };

export const DeleteSettingCouriers = (id, token) => {
  const url = `${APIPaths.transportProvider}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetShipmentPointsByID = (token, id) => {
  const url = `${APIPaths.getShipmentPoints}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// added by Shahzaib
// Create Teams List
export const CreateTeam = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.teams, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("CreateTeam Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Get Teams List
export const GetTeams = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.teams, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("GetTeams Error:", error?.response);
        reject(error?.response);
      });
  });
};

//Update Team
export const UpdateTeam = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut("Post", `${APIPaths.teams}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("UpdateTeam Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Delete Team
export const DeleteTeam = (token, id) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", `${APIPaths.teams}${id}/`, null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Delete Team Error:", error?.response);
        reject(error?.response);
      });
  });
};

// added by Shahzaib
//locations
// Create Location
export const CreateLocation = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.locations, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("CreateLocation Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Get Locations List
export const GetLocations = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.locations, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("GetLocations Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Update Location
export const UpdateLocation = (token, id, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut("Put", `${APIPaths.locations}/${id}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("UpdateLocation Error:", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteLocation = (token, id) => {
  const url = `${APIPaths.settingsLocation}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//added by shahzaib
//contacts
// Create Contact
export const CreateContact = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.contacts, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("CreateContact Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Get Contacts List
export const GetContacts = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.contacts, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("GetContacts Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Update Contact
export const UpdateContact = (token, id, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut("Put", `${APIPaths.contacts}/${id}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("UpdateContact Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Delete Contact
export const DeleteContact = (token, id) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", `${APIPaths.contacts}/${id}`, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("DeleteContact Error:", error?.response);
        reject(error?.response);
      });
  });
};


export const GetUsersByTeamIds = (token, teamIds = []) => {
  const teamsParam = teamIds.join(","); // ✅ plain comma-separated string

  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        "Get",
        `${APIPaths.teamUsers}?teams=${teamsParam}`, // ✅ no URLSearchParams
        token,
        null
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Get users by team ids error", error?.response);
        reject(error?.response);
      });
  });
};




// get all pending user [mahtab]

export const GetAllPendingUsers = (token, isActive = null) => {
  const params = new URLSearchParams();

  if (isActive === null) {
    params.append("is_pending", "true");
  } else {
    params.append("is_active", isActive);
  }

  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", `${APIPaths.users}?${params.toString()}`, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Get users error", error?.response);
        reject(error?.response);
      });
  });
};

// Delete User
export const DeleteUser = (token, id) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", `${APIPaths.users}/${id}`, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Delete User Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Delete Pending Invite User
export const DeletePendingInviteUser = (token, id) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", `${APIPaths.users}${id}/`, null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Delete pending invite user Error:", error?.response);
        reject(error?.response);
      });
  });
};

// Resend Invite
export const ResendInvite = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.resendInvite, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Resend invite Error:", error?.response);
        reject(error?.response);
      });
  });
};

export const AiFlowToggle = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.aiToggle, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("Resend invite Error:", error?.response);
        reject(error?.response);
      });
  });
};

export const GetAiToggleStatus = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.aiToggle, token)
      .then((res) => resolve(res))
      .catch((error) => reject(error?.response));
  });
};
export const GetAlertThresholds = (token, query = "") => {
  return new Promise((resolve, reject) => {
    interceptor
    .axiosGet("Get", `${APIPaths.alertThreshold}${query}`, token)
    .then((res) => resolve(res))
    .catch((err) => reject(err?.response));
  });
};

export const SaveAlertThresholds = (token, payload) => {
  return new Promise((resolve, reject) => {
    interceptor
    .axiosPost("Post", APIPaths.alertThreshold, payload, token)
    .then((res) => resolve(res))
    .catch((err) => reject(err?.response));
  });
};

export const SubmitCompnayInfo = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
    .axiosPost("Post", APIPaths.companyInfo, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error setting company info", error?.response);
        reject(error?.response);
      });
    });
  };
  
  export const GetCompnayInfo = (token) => {
    return new Promise((resolve, reject) => {
      interceptor
        .axiosGet("Get", APIPaths.companyInfo, token)
        .then((res) => resolve(res))
        .catch((error) => reject(error?.response));
    });
  };